import { Link } from "wouter";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

interface ClientReferralBannerProps {
  reward?: number;
}

export function ClientReferralBanner({ reward = 5000 }: ClientReferralBannerProps) {
  return (
    <Card className="mb-6 lg:mb-8 text-white border-0" style={{ background: 'linear-gradient(to right, #2B54BB, #63C2F1)' }}>
      <CardContent className="p-4 sm:p-6 lg:p-8">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          <div className="min-w-0 flex-1 text-center sm:text-left">
            <h2 className="text-lg sm:text-xl lg:text-2xl font-bold mb-2 space-grotesk">
              Refer a Client & Earn Rewards
            </h2>
            <p className="text-sm sm:text-base lg:text-lg font-semibold">
              R{reward?.toLocaleString()} for successful client referrals
            </p>
          </div>
          <div className="flex items-center">
            <Link href="/client-referral">
              <Button 
                variant="primary"
                size="md"
                className="w-full sm:w-auto"
                data-testid="button-refer-client"
              >
                REFER CLIENT
              </Button>
            </Link>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
